import { Configuration, ConfigurationObject } from "@shared/interfaces/Configuration";

const { REACT_APP_ENV = "local" } = process.env;

const local: Configuration = {
  env: REACT_APP_ENV,
  clarity: { id: "p2t33dq4hf" },
  baseApiUrl: "http://localhost:4000/api/v1/",
  appUrl: "http://localhost:3000",
  aws: {
    s3: {
      cdnDomainDisputes: "https://cdn.dev.dataflik.com",
      cdnDomainBuyers: "https://cdn.dev.dataflik.com",
      cdnDomain: "https://cdn.dev.dataflik.com",
    },
  },
  googleMapKey: "AIzaSyAlidstHmcUV9zUlJ951ljxCsXFxms3Lf4",
  communityUrl: "https://dataflik-community.circle.so/users/sign_in",
  reiSift: {
    oauthUrl: "https://app.staging.reisift.io/oauth",
    appUrl: "https://app.staging.reisift.io",
    siteUrl: "https://reisift.io",
  },
};

const dev: Configuration = {
  ...local,
  appUrl: "https://app.dev.dataflik.com",
  baseApiUrl: "https://api.dev.dataflik.com/api/v1/",
};

const qa: Configuration = {
  ...local,
  appUrl: "https://app.qa.dataflik.com",
  baseApiUrl: "https://api.qa.dataflik.com/api/v1/",
};

const uat: Configuration = {
  ...local,
  appUrl: "https://app.uat.dataflik.com",
  baseApiUrl: "https://api.uat.dataflik.com/api/v1/",
};

const sandbox: Configuration = {
  ...local,
  appUrl: "https://app.sandbox.dataflik.com",
  baseApiUrl: "https://api.sandbox.dataflik.com/api/v1/",
};

const production: Configuration = {
  ...local,
  clarity: { id: "p2t1vwteg9" },
  appUrl: "https://app.dataflik.com",
  baseApiUrl: "https://api.dataflik.com/api/v1/",
  aws: {
    s3: {
      cdnDomainDisputes: "https://cdn.dataflik.com",
      cdnDomainBuyers: "https://cdn.dataflik.com",
      cdnDomain: "https://cdn.dataflik.com",
    },
  },
  reiSift: {
    oauthUrl: "https://app.reisift.io/oauth",
    appUrl: "https://app.reisift.io",
    siteUrl: "https://reisift.io",
  },
};

const config: ConfigurationObject = {
  local,
  dev,
  qa,
  uat,
  sandbox,
  production,
};

const configElement: Configuration = config[REACT_APP_ENV];
export default configElement;
